/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioHeadphonesIcon20Solid = forwardRef('MediaAudioHeadphonesIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 10a8 8 0 1 1 16 0v5.5a2.5 2.5 0 0 1-2.5 2.5h-1a2.5 2.5 0 0 1-2.5-2.5v-3a2.5 2.5 0 0 1 2.5-2.5h1c.171 0 .338.017.5.05V10a6 6 0 0 0-12 0v.05c.162-.033.329-.05.5-.05h1A2.5 2.5 0 0 1 8 12.5v3A2.5 2.5 0 0 1 5.5 18h-1A2.5 2.5 0 0 1 2 15.5V10Z" })));
});
